<template>
  <div class="containerBox" ref="box">
    <!--  顶部导航  -->
    <nav-bar/>
    <!--  轮播图  -->
    <banner-list :banner-list="bannerList"/>
    <!--  公司简介  -->
    <div id="profile">
      <div class="container">
        <div class="profile_title_en" v-scroll-reveal><span>Bief introduction</span></div>
        <div class="profile_title" v-scroll-reveal>公司简介</div>
        <p style="margin-top: 40px;">山东云水网运物流有限公司成立以来在技术团队的努力下，注册申请了几十项域名、商标、软著等资质并相继获得icp增值电信业务资质，
          等保三级安全资质与网络货运许可证等资质，自主研发了从2.0到3.0 3.2的网络货运平台系统。</p>
        <p>公司自主研发的网络货运3.0系统获得了山东省交通厅与交通部技术专家的线上功能认定，
          集成了大数据、云计算、GPS、北斗双定位、轨迹记录、电子合同、电子支付等互联网技术，
          解决了政府税务等职能部门对物流运输环节业务真实性的监管难问题，解决了企业开具运输发票合规性的问题。</p>
        <p>公司相继联合全国货运知名平台货满满与地方政府合作达成共建网络货运数字产业园的战略意向协议，
          面向全国物流货运企业招商，发挥公司平台具有的技术团队优势、系统产品优势、资质优势、政策优势、
          运营优势、品牌优势，为传统的物流企业赋能数字化、信息化、智能化升级，提供技术支持、系统产品支持、办理资质牌照全流程服务支持、政策优惠申请支持与运营指导服务支持。</p>
      </div>
    </div>
    <div class="company_bg" v-scroll-reveal="{origin: 'right'}">
      <img src="https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/bg/profile_bg.png" alt="">
    </div>
    <!--  公司简介  -->
    <div id="culture" class="container" v-scroll-reveal>
      <div class="title">企业文化</div>
      <div class="title_border"></div>
      <!--      v-scroll-reveal="{origin: 'left'}"-->
      <div class="nav">
        <div class="nav_item">
          <img src="https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/icon/chengxin.png" alt="">
          <span>诚信友善</span>
        </div>
        <div class="nav_item">
          <img src="https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/icon/gongping.png" alt="">
          <span>公平共享</span>
        </div>
        <div class="nav_item">
          <img src="https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/icon/kehu.png" alt="">
          <span>客户至上</span>
        </div>
        <div class="nav_item">
          <img src="https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/icon/tuanjie.png" alt="">
          <span>团结合作</span>
        </div>
      </div>
      <!--  愿景和使命  -->
      <div class="mission">
        <div class="bg1">
          <img src="https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/bg/mission_bg.png" alt="">
        </div>
        <div class="bg2">
          <div class="bg2_box">
            <div class="bg2_title">02.</div>
            <div class="bg2_sub_title">愿景和使命</div>
            <div class="bg2_des">Vision and <span>Mission</span></div>
            <p>细节决定成败，选择成就未来</p>
            <p>变化与创新</p>
          </div>
        </div>
      </div>
    </div>
    <!--  发展历程  -->
    <div id="develop">
      <div class="container1" style="overflow: hidden;">
        <div class="title" style="color: #FFFFFF;" v-scroll-reveal>发展历程</div>
        <div class="title_border" v-scroll-reveal></div>
        <div class="develop_top">
          <div class="image">
            <img :src="developData[developIndex].imgSrc" alt="">
          </div>
          <div class="dev_content">
            <div class="dev_content_year">{{ developData[developIndex].title }}</div>
            <div class="dev_content_center">{{ developData[developIndex].content }}</div>
            <div class="dev_btn">
              <div class="dev_btn_left"></div>
              <div class="dev_btn_right"></div>
            </div>
          </div>
        </div>
        <div class="develop_bot swiper-container" ref="mySwiper">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(item, index) in developData" :key="index">
              <div class="develop_bot_item">
                <div class="dotted" :index="index"
                     :style="developIndex === index ? 'background-color: rgba(255,255,255, 1)' : 'background-color: rgba(255,255,255, 0)'"></div>
                <div class="time">{{ item.time }}</div>
              </div>
            </div>
          </div>
          <!--          <template v-for="i in 9" >
                      <div class="develop_bot_item" :key="i">
                        <div class="dotted"></div>
                        <div class="time">2022.0{{ i }}</div>
                      </div>
                    </template>-->
        </div>
      </div>
    </div>
    <!--  企业荣誉 v-scroll-reveal="{origin: 'top'}" -->
    <div id="honor">
      <div class="line"></div>
      <div class="container">
        <div class="title">企业荣誉</div>
        <div class="title_border"></div>
        <!--    荣誉轮播    -->
        <div class="swiper-container swiperHoron" style="width: 1200px;margin-top: 50px;">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(item, index) in honorData" :key="index">
              <div class="honorBox">
                <div class="honorBoxB"></div>
                <div class="content">
                  <img class="content_bg"
                       src="https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/icon/honor.png" alt="">
                  <p>{{ item.name }}</p>
                  <div class="imgBox">
                    <img :class="{img1: !item.isLong}" :src="item.imgSrc" alt="">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="btn">
          <!-- 如果需要导航按钮 -->
          <div class="swiper-button-prev1"></div>
          <div class="swiper-button-next1"></div>
        </div>
      </div>
    </div>
    <!--  底部  -->
    <bottom-footer/>
    <!--  悬浮按钮  -->
    <fix-anchor @goBottom="goBottom" :box="$refs['box']"/>
  </div>
</template>

<script>
import NavBar from '@/components/nav-bar.vue';
import BannerList from '@/components/banner-list.vue';
import BottomFooter from '@/components/bottom-footer.vue';
import FixAnchor from '@/components/fix-anchor.vue';
import 'swiper/dist/js/swiper';
import 'swiper/dist/css/swiper.css';
import Swiper from 'swiper';

export default {
  name: 'AboutUs',
  components: {
    NavBar,
    BannerList,
    BottomFooter,
    FixAnchor,
  },
  data() {
    return {
      develop_bot: null,
      bannerList: [{coverImgUrl: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/banner/about_banner.png'}],
      developIndex: 0,
      developData: [
        {
          title: '1999年',
          content: '山东高唐乘风配货中心成立，成为县域内首家物流配货信息部',
          imgSrc: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/dev/dev1.png',
          time: '1999'
        },
        {
          title: '2011年',
          content: '公司前身山东高唐佳通运输公司成立并与山东时风集团深度合作，整合17.5米平板300多辆，无车承运业务达几千万',
          imgSrc: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/dev/dev2.png',
          time: '2011'
        },
        {
          title: '2014年',
          content: '与山西鲁晋王曲电厂深度合作，整合13米标箱运力3000多辆，无车承运业务达几千万',
          imgSrc: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/dev/dev3.png',
          time: '2014'
        },
        {
          title: '2015年8月',
          content: '北京公司成立',
          imgSrc: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/dev/dev4.png',
          time: '2015.08'
        },
        {
          title: '2015年11月',
          content: '货满满平台1.0上线',
          imgSrc: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/dev/dev6.png',
          time: '2015.11'
        },
        {
          title: '2017年',
          content: '与中国万达深度合作，煤炭物流无车承运业务达几千万',
          imgSrc: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/dev/dev6.png',
          time: '2017'
        },
        // {
        //   title: '2017年10月',
        //   content: '注册用户突破10万',
        //   imgSrc: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/dev/dev6.png',
        //   time: '2017.10'
        // },
        {
          title: '2020年4月',
          content: '山东云水网运物流有限公司成立',
          imgSrc: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/dev/dev7.png',
          time: '2020.04'
        },
        {
          title: '2021年6月',
          content: '获得公安部三级等保资质',
          imgSrc: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/dev/dev9.png',
          time: '2021.06'
        },
        {
          title: '2021年7月',
          content: '货满满平台3.0上线',
          imgSrc: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/dev/dev10.png',
          time: '2021.07'
        },
        {
          title: '2021年8月',
          content: '通过山东省交通厅线上功能认定',
          imgSrc: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/dev/dev10.png',
          time: '2021.07'
        },
        {
          title: '2021年9月',
          content: '网络货运牌照获批',
          imgSrc: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/dev/dev11.png',
          time: '2021.09'
        },
        {
          title: '2021年11月',
          content: '货满满平台3.01上线，与高唐地方政府达成战略合作，启动共建网络货运数字产业园项目',
          imgSrc: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/dev/dev12.png',
          time: '2021.11'
        },
        {
          title: '2021年12月',
          content: '注册用户破万，公司获批十几项软著',
          imgSrc: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/dev/dev13.png',
          time: '2021.12'
        },
        {
          title: '2022年7月',
          content: '货满满平台3.01注册用户近10万',
          imgSrc: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/dev/dev14.png',
          time: '2022.07'
        },
      ],
      honorData: [
        {
          name: '计算机软件著作权登记证书1',
          imgSrc: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/honor/jsjrjzzq.png',
          isLong: true
        },
        {
          name: '计算机软件著作权登记证书2',
          imgSrc: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/honor/jsjrjzzq1.png',
          isLong: true
        },
        {
          name: '计算机软件著作权登记证书3',
          imgSrc: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/honor/jsjrjzzq2.png',
          isLong: true
        },
        {
          name: '计算机软件著作权登记证书4',
          imgSrc: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/honor/jsjrjzzq3.png',
          isLong: true
        },
        {
          name: '经营许可证',
          imgSrc: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/honor/jyxkz.png',
          isLong: true
        },
        {
          name: '商标注册证',
          imgSrc: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/honor/sbzcz.png',
          isLong: true
        },
        {
          name: '网络货运许可证',
          imgSrc: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/honor/wlhyxkz.png',
          isLong: false
        },
        {
          name: '信息系统安全',
          imgSrc: 'https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/honor/xxxtaq.png',
          isLong: false
        }
      ]
    };
  },
  created() {

  },
  watch: {
    developIndex(nVal) {
      this.develop_bot.slideTo(nVal);
      // console.log(nVal,oVal)
    }
  },
  mounted() {
    let that = this;
    new Swiper('.swiperHoron', {
      direction: 'horizontal', // 垂直切换选项
      slidesPerView: 3,
      spaceBetween: 5,
      loop: true, // 循环模式选项
      observer: true,
      observeParents: true,
      autoplayDisableOnInteraction: false,
      autoplay: false,
      // // 如果需要前进后退按钮
      navigation: {
        nextEl: '.swiper-button-next1',
        prevEl: '.swiper-button-prev1',
      },
    });
    this.develop_bot = new Swiper('.develop_bot', {
      direction: 'horizontal', // 垂直切换选项
      slidesPerView: 8.45,
      loop: false, // 循环模式选项
      observer: true,
      observeParents: true,
      autoplayDisableOnInteraction: false,
      autoplay: {
        delay: 2000,
      },
      navigation: {
        nextEl: '.dev_btn_right',
        prevEl: '.dev_btn_left',
      },
      on: {
        click: function () {
          that.developIndex = this.clickedIndex;
        },
        slideNextTransitionStart: function () {
          that.developIndex = this.activeIndex;
        },
        slidePrevTransitionEnd: function () {
          that.developIndex = this.activeIndex;
        },
      }
    });
    setInterval(() => {
      if (this.developIndex > 13) {
        this.developIndex = 0;
      } else {
        this.developIndex++;
      }
    }, 3000);
  },
  methods: {
    /**
     * @description: 页面滚动到顶部
     * @author: 书童
     */
    goBottom() {
      let top = this.$refs.box.offsetHeight, scrollTop = document.body.scrollTop,
          clientHeight = document.documentElement.clientHeight;
      // 实现滚动效果
      const timeTop = setInterval(() => {
        document.body.scrollTop = document.documentElement.scrollTop = scrollTop += 50;
        if (top <= (scrollTop + clientHeight)) {
          clearInterval(timeTop);
        }
      }, 10);
    },
  }
};
</script>

<style lang="scss" scoped>
.containerBox {
  overflow: hidden;
}

.btn {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
  width: 100%;
  margin-top: 40px;

  .swiper-button-prev1 {
    width: 60px;
    height: 60px;
    background: url('https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/icon/you_black.png');
    transform: rotate(180deg);
    background-size: 60px 60px;
  }

  .swiper-button-next1 {
    width: 60px;
    height: 60px;
    background: url('https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/icon/you_black.png');
    background-size: 60px 60px;
    margin-left: 70px;
  }
}

.swiper-button-next1:hover {
  background: url('https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/icon/zuo.png');
  transform: rotate(180deg);
}

.swiper-button-prev1:hover {
  transform: rotate(0deg);
  background: url('https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/icon/zuo.png');
}

.swiper-wrapper {
  display: flex;
  justify-content: space-between;
}

.swiper-slide {
  //display: flex;
  //justify-content: center;
  //align-items: center;
  //width: 306px;
  //height: 490px;
  //background-color: #ffffff;
  .honorBox {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 306px;
    height: 408px;
    background: #ffffff;
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.10);
    margin-top: 72px;
    border-bottom: 4px solid #FFFFFF;

    .honorBoxB {
      position: absolute;
      left: 0;
      bottom: 0;
      width: 0;
      height: 4px;
      background: #3A9DFC;
    }

    .content {
      position: relative;
      width: 286px;
      height: 388px;
      border: 2px solid rgba(47, 136, 255, 0.20);

      .content_bg {
        position: absolute;
        left: 0;
        right: 0;
        top: -83px;
        margin: auto;
        width: 72px;
        height: 94px;
        z-index: 12;
      }

      p {
        height: 51px;
        font-size: 18px;
        font-family: PingFang SC, PingFang SC-Medium;
        font-weight: 500;
        text-align: center;
        color: #333333;
        line-height: 25px;
        margin-top: 38px;
      }

      .imgBox {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 299px;
        width: 100%;
        //background-color: gold;
        & > img {
          display: block;
          width: 187px;
          height: 259px;
        }

        .img1 {
          width: 246px;
          height: 178px;
        }
      }
    }
  }

  .honorBox:hover .honorBoxB {
    width: 100%;
    transition: width 0.6s;
    //border-bottom: 4px solid #3A9DFC;
    //box-sizing: border-box;
  }
}

.title {
  font-size: 30px;
  font-family: PingFang SC, PingFang SC-Bold;
  font-weight: 700;
  text-align: center;
  color: #333333;
  line-height: 42px;
  margin-top: 70px;
}

.title_border {
  width: 40px;
  height: 2px;
  background: #f39801;
  margin: 6px auto 0;
}

#profile {
  width: 100%;
  height: 555px;

  .container {
    width: 1060px;
    margin: 0 auto;

    .profile_title_en {
      height: 78px;
      margin-top: 85px;
      text-align: left;

      span {
        display: inline-block;
        height: 78px;
        font-size: 40px;
        line-height: 76px;
        font-family: PingFang SC, PingFang SC-Bold;
        font-weight: 700;
        color: #666666;
        border-bottom: 2px solid #999999;
        box-sizing: border-box;
      }
    }

    .profile_title {
      height: 42px;
      font-size: 30px;
      font-family: PingFang SC, PingFang SC-Bold;
      font-weight: 700;
      text-align: LEFT;
      color: #333333;
      line-height: 42px;
      margin-top: 20px;
    }

    p {
      font-size: 16px;
      font-family: PingFang SC, PingFang SC-Medium;
      font-weight: 500;
      text-align: LEFT;
      color: #333333;
      line-height: 30px;
      margin-top: 30px;
    }
  }

}

.company_bg {
  display: flex;
  justify-content: flex-start;
  width: 100%;
  height: 300px;

  img {
    height: 100%;
    width: 1560px;
  }
}

#culture {
  //height: 886px;
  margin-bottom: 70px;

  .nav {
    display: flex;
    justify-content: space-between;
    align-self: center;
    height: 60px;
    margin-top: 60px;
    padding: 0 87px;
    box-sizing: border-box;

    .nav_item {
      display: flex;
      align-items: center;

      img {
        display: inline-block;
        width: 60px;
        height: 60px;
        margin-right: 20px;
      }

      span {
        font-size: 16px;
        font-family: PingFang SC, PingFang SC-Bold;
        font-weight: 700;
        color: #000000;
      }
    }
  }

  .mission {
    position: relative;
    width: 100%;
    height: 456px;
    margin-top: 50px;

    .bg1 {
      position: absolute;
      left: 0;
      top: 53px;
      width: 721px;
      height: 403px;
      z-index: 1;

      img {
        display: block;
        width: 100%;
        height: 100%;
      }
    }

    .bg2 {
      position: absolute;
      left: 181px;
      top: 0;
      width: 868px;
      height: 436px;
      background-color: #F6F6F6;
      z-index: -1;

      .bg2_box {
        position: absolute;
        left: 600px;
        top: 30px;
        width: 400px;

        .bg2_title {
          font-size: 120px;
          font-family: PingFang SC, PingFang SC-Bold;
          font-weight: 700;
          text-align: LEFT;
          color: rgba(78, 155, 255, 0.50);
          line-height: 168px;
        }

        .bg2_sub_title {
          font-size: 30px;
          font-family: PingFang SC, PingFang SC-Bold;
          font-weight: 700;
          text-align: LEFT;
          color: #333333;
          line-height: 42px;
        }

        .bg2_des {
          font-size: 40px;
          font-family: PingFang SC, PingFang SC-Bold;
          font-weight: 700;
          text-align: LEFT;
          color: #999999;
          line-height: 56px;
          opacity: 0.3;

          span {
            color: #4E9BFF;
          }
        }

        p {
          font-size: 18px;
          font-family: PingFang SC, PingFang SC-Medium;
          font-weight: 500;
          text-align: LEFT;
          color: #333333;
          line-height: 25px;
          margin-top: 20px;
        }
      }
    }

  }
}

#develop {
  overflow: hidden;
  width: 100%;
  height: 686px;
  background: url(https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/bg/develop.png);
  background-size: 100% 686px;
  padding-top: 1px;
  box-sizing: border-box;

  .container1 {
    overflow: hidden;
    width: 1200px !important;
    margin: 0 auto;

    .develop_top {
      display: flex;
      justify-content: space-between;
      width: 100%;
      height: 322px;
      margin-top: 50px;

      .image {
        width: 562px;
        height: 322px;
        margin-right: 80px;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .dev_content {
        flex: 1;

        .dev_content_year {
          font-size: 30px;
          font-family: PingFang SC, PingFang SC-Bold;
          font-weight: 700;
          text-align: LEFT;
          color: #ffffff;
          line-height: 42px;
          margin-top: 62px;
        }

        .dev_content_center {
          height: 44px;
          font-size: 16px;
          font-family: PingFang SC, PingFang SC-Medium;
          font-weight: 500;
          text-align: LEFT;
          color: #ffffff;
          line-height: 22px;
          margin-top: 14px;
        }

        .dev_btn {
          display: flex;
          justify-content: flex-start;
          height: 60px;
          width: 100%;
          margin-top: 80px;

          .dev_btn_left {
            width: 60px;
            height: 60px;
            background: url('https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/icon/you.png');
            transform: rotate(180deg);
            background-size: 60px 60px;
          }

          .dev_btn_right {
            width: 60px;
            height: 60px;
            background: url('https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/icon/you.png');
            background-size: 60px 60px;
            margin-left: 70px;
          }

          .dev_btn_left:hover {
            background: url('https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/icon/zuo.png');
            transform: rotate(0deg);
          }

          .dev_btn_right:hover {
            background: url('https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/icon/zuo.png');
            transform: rotate(180deg);

          }
        }
      }
    }

    ::v-deep .swiper-container {
      overflow: hidden;
      width: 1200px !important;
    }

    .develop_bot {
      //overflow-x: auto;
      overflow: hidden;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: nowrap;
      width: 1200px !important;
      height: 88px;
      margin-top: 77px;

      .develop_bot_item {
        position: relative;
        width: 142px !important;
        height: 48px;
        background: url('https://hmm3.oss-cn-shanghai.aliyuncs.com/applet/webSitePic/PC/dev/line.png') no-repeat;
        background-size: 142px 16px;
        text-align: center;
        cursor: pointer;

        & > .time {
          width: 142px;
          font-size: 16px;
          font-family: PingFang SC, PingFang SC-Medium;
          font-weight: 500;
          color: rgba(255, 255, 255, 0.8);
          line-height: 22px;
          text-align: center;
          z-index: 1;
          margin-top: 6px;
        }

        & > .dotted {
          //position: absolute;
          //left: 0;
          //right: 0;
          //top: 0px;
          margin: 0 auto;
          height: 20px;
          width: 20px;
          border-radius: 50%;
          background-color: rgba(255, 255, 255, 0);
        }
      }
    }
  }

}

#honor {
  position: relative;
  height: 841px;
  width: 100%;

  .line {
    position: absolute;
    left: 0;
    top: 218px;
    width: 100%;
    height: 4px;
    background: rgba(78, 155, 255, 0.20);
    z-index: -1;
  }
}
</style>